import { useTranslation } from 'react-i18next';

const PublicReviewCard = ({ review }) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-zinc-100 dark:bg-zinc-800 font-medium">
          {review.clientFirstName?.[0]}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-medium">{review.clientFirstName}</p>
          <p className="text-xs text-amber-400">{'★'.repeat(review.rating)}</p>
          {review.subjectName && (
            <p className="text-xs text-zinc-500">
              {t(`reviews.types.${review.type}`)} · {review.subjectName}
            </p>
          )}
        </div>
        <span className="text-xs text-zinc-600 dark:text-zinc-500">
          {new Date(review.createdAt).toLocaleDateString()}
        </span>
      </div>
      {review.comment && (
        <p className="mt-3 text-sm text-zinc-600 dark:text-zinc-400">{review.comment}</p>
      )}
      {review.reply?.message && (
        <div className="mt-3 rounded-lg border border-glow-800/30 bg-glow-950/20 p-3 text-sm">
          <p className="text-xs font-medium text-glow-300">
            {t('reviews.salonReply')}
            {review.reply.repliedByName ? ` · ${review.reply.repliedByName}` : ''}
          </p>
          <p className="mt-1 text-zinc-600 dark:text-zinc-400">{review.reply.message}</p>
        </div>
      )}
    </div>
  );
};

export default PublicReviewCard;
